module.exports = __webpack_public_path__ + "img/upcommingEvents3.dddc0038.jpg";